import { CustomPicker } from 'react-color';
var { Alpha, Hue, Saturation, EditableInput } = require('react-color/lib/components/common');

const Picker = props => {

    const {color,onChange,hasInput} = props;
    const input = hasInput ? <div className='flex mt-3 items-center'>
        <div className='minititle min-w-[60px] sk'>Value</div>
        <EditableInput value={color} onChange={onChange} />
    </div> : []
    
    return <div className='picker'>
        
        <div className='relative h-40 rounded-sm overflow-hidden'>
            <Saturation {...props} />
        </div>
        <div className='my-3 flex items-center'>
            <div className='min-w-[60px] minititle'>Hue</div>
            <div className='flex-1 relative h-3 rounded-sm overflow-hidden'>
                <Hue {...props} direction={ 'horizontal' } />
            </div>
        </div>
        <div className='flex items-center'>
            <div className='minititle min-w-[60px]'>Alpha</div>
            <div className='flex-1 bg-white relative h-3 rounded-sm overflow-hidden'>
                <Alpha {...props}/>
            </div>
        </div>
        {input}
</div>
      
}

export default CustomPicker(Picker)